import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {SessionStorageAdsRepository} from '../Repositories/SessionStorageAdsRepository.js'

class ClearComparatorAdsUseCase extends UseCase {
  #repository

  #handleError(error) {
    return Promise.reject(
      DomainSharedError.isDomainError({error}) ? error : DomainSharedError.createGenericError({cause: error})
    )
  }

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create() {
    return new ClearComparatorAdsUseCase({repository: SessionStorageAdsRepository.create()})
  }

  @tracer({metric: 'ClearComparatorAdsUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    try {
      const [error, response] = await this.#repository.clearComparatorAds()
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = ClearComparatorAdsUseCase.create
